import React, { useState } from 'react';
import Drawer from 'rc-drawer';
import motionProps from "../../../utils/motion";
import { CSSTransition } from 'react-transition-group';

// Data // 
import { Dates, Categories, Themes } from "../../../data/biblioteca.data.js"

// Styles //
import 'rc-drawer/assets/index.css';
import "./filterMobile.scss";

interface FilterMobileInterface {
    setActivedTheme: (theme: string) => void;
    setSelectedCategory: (category: any) => void;
    onChangeDate: (option: any) => void;
}

const FilterMobile = (props: FilterMobileInterface) => {
    const {setActivedTheme, onChangeDate, setSelectedCategory} = props;
    const [openDrawer, setOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState<string>('order');
    const [dateCheck, setDateCheck] = useState<string>("");
    const [themeCheck, setThemeCheck] = useState<string>("");
    const [categoryCheck, setCategoryCheck] = useState<any[]>([]);
    const [checkedCategory, setCheckedCategory] = useState({});

    const onSwitchDrawer = (e) => {
        setOpen(c => !c);
        setActiveMenu(e.target.dataset.menu);
    };

    const handleChangeTheme = (value) => {
        setThemeCheck(value);
        setActivedTheme(value);
    }

    const handleChangeDate = (value) => {
        onChangeDate(value);
        setDateCheck(value.label);
    }

    const handleChangeCategory = (e) => {
        const { value, checked } = e.target;
        setCheckedCategory({...checkedCategory, [e.target.name] : e.target.checked });
        if (checked) {
            setCategoryCheck([...categoryCheck, {
                value: value,
                label: value
            }]);
            setSelectedCategory([...categoryCheck, {
                value: value,
                label: value
            }]);
        } else {
            setCategoryCheck(categoryCheck.filter((e) => e.value !== value));
            setSelectedCategory(categoryCheck.filter((e) => e.value !== value));
        }
    }

    const handleClean = () => {
        setSelectedCategory([]);
        setActivedTheme("Todos");
        setDateCheck("");
        setThemeCheck("");
        setCheckedCategory({})
    }

    const DropdownItem = (props) => {
        return (
            <a href="#" className="menu-item" onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}>
                {props.children}
            </a>
        );
    }

    return (
        <div className="o-filter-mobile">
            <div className="o-filter-mobile__buttons">
                <button data-menu="filter" onClick={onSwitchDrawer}>Filtrar por:</button>
                <button data-menu="order" onClick={onSwitchDrawer}>Ordenar por:</button>
            </div>
            <Drawer
                open={openDrawer}
                onClose={onSwitchDrawer}
                placement="right"
                width="80%"
                {...motionProps}>
                <div className="o-filter-mobile__content">
                    <CSSTransition
                        in={activeMenu === 'filter'}
                        timeout={500}
                        classNames="menu-primary"
                        unmountOnExit>
                        <div className="menu">
                            <div className="menu__header">
                                <button onClick={onSwitchDrawer}><i className="icon-arrow-left"></i> Filtrar por:</button>
                            </div>
                            <div className="menu__content">
                                <ul>
                                    <li>
                                        <DropdownItem goToMenu="theme">Temática <i className="icon-chevron-right"></i></DropdownItem>
                                    </li>
                                    <li>
                                        <DropdownItem goToMenu="category">Categoría <i className="icon-chevron-right"></i></DropdownItem>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </CSSTransition>
                    <CSSTransition
                        in={activeMenu === 'order'}
                        timeout={500}
                        classNames="menu-primary"
                        unmountOnExit>
                        <div className="menu">
                            <div className="menu__header">
                                <button onClick={onSwitchDrawer}><i className="icon-arrow-left"></i> Ordenar por:</button>
                            </div>
                            <div className="menu__content">
                                {Dates.slice(0,-1).map((item, i) => (
                                    <DropdownItem>
                                        <label htmlFor={`date-${i}`}>
                                            <input 
                                                type="checkbox" 
                                                id={`date-${i}`} 
                                                checked={item.value === dateCheck}
                                                onChange={() => handleChangeDate({value: item.value, label: item.label})}/>
                                            {item.label}
                                        </label>
                                    </DropdownItem>
                                ))}
                            </div>
                            <div className="menu__footer">
                                {activeMenu === "order" && (
                                    <>
                                        <button onClick={handleClean}>Limpiar</button>
                                        <button onClick={onSwitchDrawer}>Aplicar</button>
                                    </>
                                )}
                            </div>
                        </div>
                    </CSSTransition>
                    <CSSTransition
                        in={activeMenu === 'theme'}
                        timeout={500}
                        classNames="menu-secondary"
                        unmountOnExit>
                        <div className="menu">
                            <div className="menu__header">
                                <button onClick={() => setActiveMenu("filter")}><i className="icon-arrow-left"></i> Temática</button>
                            </div>
                            <div className="menu__content">
                                {Themes.map((item, i) => (
                                    <DropdownItem>
                                        <label htmlFor={`theme-${i}`}>
                                            <input 
                                                type="checkbox" 
                                                id={`theme-${i}`} 
                                                checked={item.value === themeCheck}
                                                onChange={() => handleChangeTheme(item.label)}/>
                                            {item.label}
                                        </label>
                                    </DropdownItem>
                                ))}
                            </div>
                            <div className="menu__footer">
                                {activeMenu === "theme" && (
                                    <>
                                        <button onClick={handleClean}>Limpiar</button>
                                        <button onClick={onSwitchDrawer}>Aplicar</button>
                                    </>
                                )}
                            </div>
                        </div>
                    </CSSTransition>
                    <CSSTransition
                        in={activeMenu === 'category'}
                        timeout={500}
                        classNames="menu-secondary"
                        unmountOnExit>
                        <div className="menu">
                            <div className="menu__header">
                                <button onClick={() => setActiveMenu("filter")}><i className="icon-arrow-left"></i> Categoría</button>
                            </div>
                            <div className="menu__content">
                                {Categories.map((item, i) => (
                                    <DropdownItem>
                                        <label htmlFor={`category-${i}`}>
                                            <input 
                                                type="checkbox" 
                                                id={`category-${i}`}
                                                value={item.value}
                                                name={item.value}
                                                checked={checkedCategory[item.value]}
                                                onChange={handleChangeCategory}/>
                                            {item.label}
                                        </label>
                                    </DropdownItem>
                                ))}
                            </div>
                            <div className="menu__footer">
                                {activeMenu === "category" && (
                                    <>
                                        <button onClick={handleClean}>Limpiar</button>
                                        <button onClick={onSwitchDrawer}>Aplicar</button>
                                    </>
                                )}
                            </div>
                        </div>
                    </CSSTransition>
                    <span className="o-filter-mobile__content__close" onClick={onSwitchDrawer}><i className="icon-close"></i></span>
                </div>
            </Drawer>
        </div>
    )
}

export default FilterMobile;